/**
 * @ngdoc module
 * @name Registration
 * @description The registration form module contains directives and controllers for registering a user and taking payment.
 */
import routerConfig from './registration.route.js';
import PurchaseController from './purchase/purchase.controller.js';
import GiftController from './gift/gift.controller.js';
import RedeemController from './redeem/redeem.controller.js';
import RegistrationService from './registration.service.js';
import {registrationStepAnimation} from './registration.animation.js';

angular.module('app.ecourse.registration', ['ui.router', 'app.services', 'ngAnimate'])
  .service('RegistrationService', RegistrationService)
  .controller('GiftController', GiftController)
  .controller('RedeemController', RedeemController)
  .controller('PurchaseController', PurchaseController)
  .animation('.registration-step-animation', registrationStepAnimation)
  .config(routerConfig);



/** WEBPACK FOOTER **
 ** ./src/app/ecourse/registration/registration.module.js
 **/